module.exports = __webpack_public_path__ + "img/yatirimlar-2.d25c9bb3.png";